import { Modal } from 'bootstrap';

export default class PopupListener {
    constructor() {
        document.addEventListener('DOMContentLoaded', function () {
            document.querySelectorAll('.modal[data-popup]').forEach((element) => {
                const modal = new Modal(element);
                modal.show();
            })
        });
    }
}